import React from 'react';
import { arrayOf, func, string } from 'prop-types';
import styled from 'styled-components';

import { COLOR_TOKENS } from 'constants/quartz';
import { brandLinkColor, brandLinkHoverColor } from 'utils/brandTheme';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    color: ${COLOR_TOKENS.feedback.info.text};
`;

const Title = styled.span`
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.438rem;
`;

const ChangeList = styled.ul`
    font-size: 0.875rem;
    line-height: 1.25rem;
    list-style: disc outside;
    margin: 0;
    padding-left: 1.125rem;
`;

const ReloadLink = styled.button`
    background: none;
    border: none;
    color: ${brandLinkColor};
    cursor: pointer;
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1.25rem;
    padding: 0;
    text-align: left;
    text-decoration: underline;

    &:hover {
        color: ${brandLinkHoverColor};
    }
`;

const CaseEditedToast = ({ changes, editorName, onReload }) => (
    <Container data-testid="case-edited-toast">
        <Title>New version published by {editorName}</Title>
        <ChangeList data-testid="case-edited-toast-changes">
            {changes.map(change => (
                <li key={change}>{change}</li>
            ))}
        </ChangeList>
        <ReloadLink data-testid="case-edited-toast-reload" onClick={onReload}>
            Reload
        </ReloadLink>
    </Container>
);

CaseEditedToast.propTypes = {
    changes: arrayOf(string).isRequired,
    editorName: string.isRequired,
    onReload: func.isRequired,
};

export default CaseEditedToast;
